export default __webpack_public_path__ + "static/mobile_12-55987e9fbdd99a797f154e59ee26cc8f.webp";